import { ApiTokensServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/api_tokens/Api_tokensServiceClientPb';
import {
  Restrictions,
  CreateApiTokenRequest,
  CreateApiTokenResponse,
  GetApiTokenRequest,
  GetApiTokenResponse,
  ListApiTokensRequest,
  ListApiTokensResponse,
  UpdateApiTokenRequest,
  UpdateApiTokenResponse,
  DeleteApiTokenRequest,
  DeleteApiTokenResponse,
  GrantRightOnApplicationRequest,
  GrantRightOnApplicationResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/api_tokens/api_tokens_pb';

export type ApiTokensExportClasses = {
  ApiTokensServiceClient: typeof ApiTokensServiceClient;
  Restrictions: typeof Restrictions;
  CreateApiTokenRequest: typeof CreateApiTokenRequest;
  CreateApiTokenResponse: typeof CreateApiTokenResponse;
  GetApiTokenRequest: typeof GetApiTokenRequest;
  GetApiTokenResponse: typeof GetApiTokenResponse;
  ListApiTokensRequest: typeof ListApiTokensRequest;
  ListApiTokensResponse: typeof ListApiTokensResponse;
  UpdateApiTokenRequest: typeof UpdateApiTokenRequest;
  UpdateApiTokenResponse: typeof UpdateApiTokenResponse;
  DeleteApiTokenRequest: typeof DeleteApiTokenRequest;
  DeleteApiTokenResponse: typeof DeleteApiTokenResponse;
  GrantRightOnApplicationRequest: typeof GrantRightOnApplicationRequest;
  GrantRightOnApplicationResponse: typeof GrantRightOnApplicationResponse;
};

export const apiTokens: ApiTokensExportClasses = {
  ApiTokensServiceClient,
  Restrictions,
  CreateApiTokenRequest,
  CreateApiTokenResponse,
  GetApiTokenRequest,
  GetApiTokenResponse,
  ListApiTokensRequest,
  ListApiTokensResponse,
  UpdateApiTokenRequest,
  UpdateApiTokenResponse,
  DeleteApiTokenRequest,
  DeleteApiTokenResponse,
  GrantRightOnApplicationRequest,
  GrantRightOnApplicationResponse,
};
